module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-1 ksm-flex-column",
    staticStyle: {
      "background-color": "#eee"
    }
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-flex-00auto"
  }, [_c('div', {
    staticClass: "ksm-medien__icon",
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('noten.svg'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-ursonate_osd-wrapper"
  }, [(_vm.seite && _vm.isReady) ? _c('DeepzoomView', {
    key: "deep_noteview",
    attrs: {
      "modusOption": _vm.modus.option,
      "seiteIdx": parseInt(_vm.localParams.noteIdx, 10),
      "seiten": _vm.seiten
    },
    on: {
      "changePage": _vm.changeSeite
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ksm-ursonate_note-wrapper"
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex-column",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "ksm-flex-column",
    staticStyle: {
      "position": "absolute",
      "height": "100%",
      "width": "100%"
    }
  }, [_c('NotenPlayer', {
    attrs: {
      "meiName": _vm.meiName,
      "seite": _vm.seite
    },
    on: {
      "transcriptUpdate": _vm.transcriptUpdate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-texte__transcript"
  }, _vm._l((_vm.seite._.docInfo), function(s, j) {
    return _c('div', [_c('p', {
      domProps: {
        "innerHTML": _vm._s(s._source['98_html'])
      }
    })])
  }), 0)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-00auto ksm-flex",
    staticStyle: {
      "height": "100px",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "ksm-texte__modus_toolbar"
  }, [_c('div', {
    staticClass: "ksm-texte__merz-select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupIdx),
      expression: "groupIdx"
    }],
    staticStyle: {
      "width": "auto"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.groupIdx = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeGroup]
    }
  }, _vm._l((_vm.notenGroup), function(g, gi) {
    return _c('option', {
      key: gi,
      domProps: {
        "value": gi
      }
    }, [_vm._v(_vm._s(g.label))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "ksm-texte__merz-select",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localParams.noteIdx),
      expression: "localParams.noteIdx"
    }],
    staticStyle: {
      "width": "auto"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.localParams, "noteIdx", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.notenGroup[_vm.groupIdx].seiten), function(s, j) {
    return _c('option', {
      key: j,
      domProps: {
        "value": s.idx + ''
      }
    }, [_vm._v(_vm._s(s.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-ursonate__thumbnail--wrapper"
  }, [(_vm.seiten) ? _c('div', {
    staticClass: "ksm-ursonate__thumbnail"
  }, [_c('Thumbnail', {
    attrs: {
      "seiten": _vm.seiten,
      "seiteIdx": parseInt(_vm.localParams.noteIdx, 10),
      "aligen": 'horizontal',
      "imageHeight": 75
    },
    on: {
      "selectItem": _vm.changeSeite
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ksm-texte__modus_info"
  }, _vm._l((_vm.seite._.docInfo), function(s, j) {
    return _c('div', [_vm._v("\n        Art der Seite: " + _vm._s(s._source["98_artderseite"]) + " "), _c('br'), _vm._v("\n        Format: " + _vm._s(s._source["98_format"]) + " "), _c('br'), _vm._v("\n        Datum: " + _vm._s(s._source["98_datumalternativ"]) + " "), _c('br'), _vm._v("\n        Standort/Eigentümer: " + _vm._s(s._source["98_standorteigen"]) + " "), _c('br'), _vm._v("\n        Signatur Sprengel Museum Hannover: " + _vm._s(s._source["98_KSAsignaturItem"]) + " "), _c('br'), _vm._v("\n        Material/Technik: " + _vm._s(s._source["98_materialtechnik"]) + " "), _c('br')])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de2edd8a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/texte/ursonate/NotenView.vue
// module id = 1997
// module chunks = 1